const navHide = {
    state:{
      isHide: true
    },
    mutations:{
      isNavShow: (state, obj) =>{
        state.isHide = obj;
      }
    }
  }
  
  export default navHide
  